import React from 'react';
import { Modal, Typography } from 'antd';
import { modal } from '../../../Tasks/configs/designTokens';
import '../../styles/index.scss';

const { Paragraph, Text } = Typography;

const PrivacyComplianceModal = ({ isModalVisible, setIsModalVisible }) => {
  return (
    <React.Fragment>
      <Modal
        title={'Privacy & Compliance'}
        wrapClassName="tags-modal"
        width={modal.lg}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        centered
        footer={null}
      >
        <Typography>
          <Paragraph>
            Our tracking tag is built <Text strong>privacy-first</Text>. Here's how we handle
            privacy and compliance across every integration:
          </Paragraph>
          <ul style={{ paddingLeft: 20, marginBottom: 16 }}>
            <li style={{ marginBottom: 8 }}>
              <Text strong>Opt-out is honored automatically.</Text> Before doing anything, the tag
              checks for <Text strong>Global Privacy Control (GPC)</Text> and{' '}
              <Text strong>Do Not Track (DNT)</Text> signals. If a visitor has opted out, the tag
              does <Text strong>not initialize</Text> — no events, cookies,{' '}
              <Text code>localStorage</Text>, or third-party beacons are ever set. GPC is legally
              recognized under CCPA/CPRA (California), Colorado CPA, Connecticut CTDPA, and other US
              state privacy laws.
            </li>
            <li style={{ marginBottom: 8 }}>
              <Text strong>First-party by design.</Text> We use first-party cookies and{' '}
              <Text code>localStorage</Text> only — no third-party cookies. Cookies use{' '}
              <Text code>SameSite=Lax</Text> and are transmitted over HTTPS only.
            </li>
            <li style={{ marginBottom: 8 }}>
              <Text strong>Data minimization.</Text> We collect only standard browser context plus
              the specific commerce, sign-up, or impression data your site explicitly passes to the
              tag. Hashed email is supported as a privacy-preserving alternative to plaintext.
            </li>
            <li style={{ marginBottom: 8 }}>
              <Text strong>Automatic PII filtering.</Text> Form tracking automatically excludes
              sensitive fields — passwords, emails, phone numbers, SSNs, payment/card details,
              security codes, auth tokens, and dates of birth are never captured.
            </li>
            <li style={{ marginBottom: 8 }}>
              <Text strong>Defense-in-depth.</Text> The underlying Snowplow SDK is configured with{' '}
              <Text code>respectDoNotTrack</Text> as an additional safeguard.
            </li>
            <li style={{ marginBottom: 8 }}>
              <Text strong>Downstream transparency.</Text> Where audience-segment partners are used,
              applicable consent signals (e.g., GDPR consent) are forwarded to them.
            </li>
            <li>
              <Text strong>Right to be forgotten.</Text> Opt-out and deletion requests are honored
              server-side through a suppression process that removes affected records from our
              analytics store.
            </li>
          </ul>
          <Paragraph type="secondary" style={{ marginBottom: 0 }}>
            These mechanisms support compliance but are <Text strong>not legal advice</Text>.
            Whether a given deployment is compliant also depends on how your site is configured, what
            data you pass to the tag, and the contracts governing downstream use.
          </Paragraph>
        </Typography>
      </Modal>
    </React.Fragment>
  );
};

export default PrivacyComplianceModal;
